import {TynnFavorittModell} from "../tjenester/ressurser/generertNg2HttpKlient";
import {erTomListe} from "../støttefunksjoner/lister";
import {Brukerkontekst} from "../tjenester/Brukerkontekst";

/** Sann dersom kallende bruker er blandt entitet.favoritter */
export function erFavorittHosKallendeBruker(entitet: HarFavoritter, kontekst: Brukerkontekst): boolean {
    if (erTomListe(entitet.favoritter)) return false;
    return entitet.favoritter.some(favoritt => favoritt.brukerId === kontekst.bruker.id);
}

export interface HarFavoritter {
    favoritter: TynnFavorittModell[];
}
